import SupportLayout from "./supportLayout";
import Tels from "common/pages/common/-pages/support/Tels";

const MorningTels = () => {
    return (
        <SupportLayout>
            <Tels />
        </SupportLayout>
    );
};

export default MorningTels;
